module.exports = __webpack_public_path__ + "static/media/beyond_meat_hero_fr.4e04b5af.jpg";